import type { App } from 'vue'
import { ref } from 'vue'
import { createI18n } from 'vue-i18n'
import { localeMessages } from '@/settings/langs'

// Reactive locale ref — used by components that need to react to locale changes
export const i18nLocale = ref<string>('en')

// Polish pluralization: 1 → singular, 2–4 (non-teen) → plural2, 0/5+/teens → plural3
function plPluralRule(choice: number): number {
  if (choice === 1)
    return 0
  const teen = choice > 10 && choice < 20
  if (!teen && choice % 10 >= 2 && choice % 10 <= 4)
    return 1
  return 2
}

// Factory — creates a fresh i18n instance with the given locale.
// Used by SSG (fresh instance per page render = no cross-render state pollution).
export function createI18nInstance(locale: string = 'en') {
  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    messages: localeMessages,
    pluralRules: { pl: plPluralRule }
  })
}

// SPA singleton — created once, locale changed reactively via setI18nLocale.
export const spaI18n = createI18nInstance()

export function setI18nLocale(locale: string) {
  i18nLocale.value = locale
  // Keep SPA singleton in sync so t() returns correct translations after locale switch.
  ;(spaI18n.global.locale as ReturnType<typeof ref<string>>).value = locale
}

// SPA Vue plugin — installs the singleton.
// mainSsg.ts does NOT use this; it installs fresh instances via createI18nInstance.
export default {
  install: (app: App) => {
    app.use(spaI18n)
  }
}
